module.exports = __webpack_public_path__ + "media/images/NHC_LOGO_PC-1cc89d3f37f4c4d84a34c3875eb8d2d0.png";